import { render, staticRenderFns } from "./DialogConfirmFileExtension.vue?vue&type=template&id=d8709144&scoped=true"
import script from "./DialogConfirmFileExtension.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogConfirmFileExtension.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogConfirmFileExtension.vue?vue&type=style&index=0&id=d8709144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8709144",
  null
  
)

export default component.exports